<template>
  <div>
    <v-row>
      <v-col class="text-center">
        <v-dialog v-model="dialog" persistent max-width="800px">
          <v-card>
            <v-card-title>
              <span class="headline"></span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-select
                      :items="allActions"
                      label="Select Action"
                      class="added-action"
                      v-model="action"
                      @change="checkActionDue"
                      item-value="name"
                      return-object
                    >
                      <template slot="selection" slot-scope="{ item }">
                        <!-- HTML that describe how select should render selected items -->
                        {{ item.name }}
                        <span v-if="item.hasDueDate" class="indigo--text ml-2">
                          -- due date enabled
                        </span>
                      </template>
                      <template slot="item" slot-scope="{ item }">
                        <!-- HTML that describe how select should render selected items -->
                        {{ item.name }}
                        <span v-if="item.hasDueDate" class="indigo--text ml-2">
                          -- due date enabled
                        </span>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="12" v-show="show_due_date">
                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :close-on-content-click="false"
                      :return-value.sync="datetime_due"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :value="datetime_due"
                          v-model="computedDateTimeDue"
                          label="Action Due Date"
                          prepend-icon="mdi-calendar"
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="datetime_due" no-title scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu = false">
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.menu.save(datetime_due)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12">
                    <span class="body-1 mb-4">Add Instructions</span>
                    <ckeditor
                      :editor="editor"
                      v-model="instructions"
                      :config="editorConfig"
                    ></ckeditor>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close()">Close</v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="updateSave()"
                :disabled="disableSave"
                >Save</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>

    <ActionTemplatesDialog
      accessFrom="route"
      :dialog2="action_template_dialog"
      :action="selected_action"
      @closeDialog="closeActionStatus"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ActionTemplatesDialog from "./actions/ActionTemplatesDialog.vue";
import moment from "moment";
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import EssentialsPlugin from "@ckeditor/ckeditor5-essentials/src/essentials";
import BoldPlugin from "@ckeditor/ckeditor5-basic-styles/src/bold";
import ItalicPlugin from "@ckeditor/ckeditor5-basic-styles/src/italic";
import ParagraphPlugin from "@ckeditor/ckeditor5-paragraph/src/paragraph";
import ListPlugin from "@ckeditor/ckeditor5-list/src/list";
import ChecklistPlugin from "@ckeditor/ckeditor5-list/src/todolist";

export default {
  props: {
    dialog: Boolean,
    allReceivers: Array,
    initiatorDueDate: String,
  },
  components: {
    ActionTemplatesDialog,
  },
  data() {
    return {
      disableSave: true,
      action: null,
      menu: false,
      users: [],
      datetime_due: this.initiatorDueDate,
      selected_action: null,
      action_template_dialog: false,
      status_template: [],
      show_due_date: false,
      action_due_date: false,
      editor: ClassicEditor,
      instructions_list: [],
      instructions: "",
      editorConfig: {
        plugins: [
            EssentialsPlugin,
            BoldPlugin,
            ItalicPlugin,
            ParagraphPlugin,
            ListPlugin,
            ChecklistPlugin,
        ],
        toolbar: {
            items: [
            "bold",
            "italic",
            "undo",
            "redo",
            "numberedList",
            "bulletedList",
            ],
        },
    },
    }
  },
  methods: {
      ...mapActions([
          "updateMultipleReceiver"
      ]),
      closeActionStatus(val) {
        this.disableSave = false
        this.action_template_dialog = false;
        this.status_template = val;
      },
      checkActionDue() {
        this.disableSave = true
        if (this.action) {
          this.selected_action = this.action;
          this.action_template_dialog = true;
          if (this.action.hasDueDate) {
            this.show_due_date = true;
            this.action_due_date = true;
          } else {
            this.show_due_date = false;
            this.action_due_date = false;
          }
        }
      },
      close() {
        this.$emit("closeDialog", false);
        this.instructions_list = [];
        this.user = [];
        this.action = null;
        this.datetime_due = this.initiatorDueDate;
      },
      updateSave(){
          const body = []
          this.allReceivers.forEach(receiver => {
            this.allUsersByOffice.forEach(element => {
                if (element.user_id == receiver.user.id) {
                    body.push({
                        user: element,
                        datetime_due: this.action_due_date ? this.datetime_due : this.initiatorDueDate,
                        selected: receiver,
                        action: this.action,
                        instructions: this.instructions,
                        instructions_list: this.instructions_list,
                        hasActionDueDate: this.action_due_date,
                        status_template: this.status_template,
                    })
                }
            });
          })
          this.updateMultipleReceiver(body).then(() => {
            this.close();
          })
      }
  },
  computed: {
    ...mapGetters(["allActions", "addedReceivers", 
        "allUsersByOffice",]),
    computedDateTimeDue() {
        return moment(new Date(this.datetime_due)).format("dddd, MMMM DD YYYY");
      },
  },
  watch: {
    dialog() {
      this.disableSave = true
    }
  }
};
</script>